import { render, staticRenderFns } from "./FeaturedBox.vue?vue&type=template&id=8254f4fc&scoped=true"
import script from "./FeaturedBox.vue?vue&type=script&lang=js"
export * from "./FeaturedBox.vue?vue&type=script&lang=js"
import style0 from "./FeaturedBox.vue?vue&type=style&index=0&id=8254f4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8254f4fc",
  null
  
)

export default component.exports